import { PureComponent } from "react";
import VideoComponent from "components/core/video/video-component";
import SignupRightDecoration from "/static/svg/decorators/signup/signup-decoration-right.svg";
import ParagraphComponent from "/components/core/paragraph/paragraph-component";
import EmbeddedFormComponent from "/components/segments/embedded-form/embedded-form-component";
export default class FormWithTextAndAssetsComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  renderParagraph() {
    const { paragraph, marginBottomParagraph } = this.props;
    return (
      <div style={{ marginBottom: marginBottomParagraph }}>
        <ParagraphComponent {...paragraph} />
      </div>
    );
  }

  renderVideo() {
    const { video } = this.props;

    if (video && video.src) {
      const { formats } = video.src;
      return <VideoComponent {...video} {...video.src} formats={formats} />;
    }
  }

  renderForm() {
    const {
      formToken,
      width,
      height,
      boxShadow,
      marginLeft,
      borderRadius,
      showFormDecorations,
      columnsMappingFromParams
    } = this.props;
    const { circle } = this.props;
    return (
      <div
        className="embedded-form-component"
        style={{ width, height, boxShadow, marginLeft, position: "relative", borderRadius }}
      >
        <div style={{ ...circle }} />
        <EmbeddedFormComponent
          formToken={formToken}
          width={width}
          height={height}
          columnsMappingFromParams={columnsMappingFromParams}
        />
        {showFormDecorations && (
          <SignupRightDecoration
            key="right-decoration"
            style={{ transform: "rotate(-25deg)", position: "absolute", top: "-20px", left: "92%" }}
          />
        )}
      </div>
    );
  }
  render() {
    const { marginTop, marginTopAsset } = this.props;
    return (
      <div>
        <div
          className="paragaph-and-asset-component"
          style={{ marginTop, display: "flex", flexWrap: "wrap", margin: "4px" }}
        >
          <div style={{ display: "block", marginTop: marginTopAsset, maxWidth: "50%" }}>
            {this.renderParagraph()}
            {this.renderVideo()}
          </div>
          <div style={{ display: "flex" }}>{this.renderForm()}</div>
        </div>
      </div>
    );
  }
}

FormWithTextAndAssetsComponent.defaultProps = {
  content: {
    topic: {
      text: "Simple and intuitive",
      color: "brand-blue"
    },
    title: "Easy onboarding, fast adoption",
    body: [
      "Getting your team onboard recuires sending an invatation, and that’s it! It’s so visual and easy to use your teammates will get hooked immediatly."
    ],
    bottomLink: {
      href: "/",
      text: "See all features"
    }
  },
  asset: {
    side: "right",
    shadow: false
  }
};
